import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';

const Details = () => {
    const { id } = useParams();
    const [pet, setPet] = useState({});
    const [loading, setLoading] = useState(true);
    const [liked, setLiked] = useState(false);
    const [toast, setToast] = useState(null);
    const navigate = useNavigate();

    const showToast = (message, type = 'success') => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 3000);
    };

    useEffect(() => {
        axios.get(`http://localhost:8000/api/displayOne/${id}`)
            .then(res => {
                console.log(res);
                setPet(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    }, [id]);

    const handleLike = () => {
        if (liked) return;

        axios.put(`http://localhost:8000/api/update/${id}`, {
            likes: pet.likes + 1
        })
            .then(res => {
                console.log(res);
                setPet({...pet, likes: pet.likes + 1});
                setLiked(true);
                showToast('You liked this pet! ❤️', 'success');
            })
            .catch(err => {
                console.log(err);
                showToast('Something went wrong', 'error');
            });
    };

    const handleAdopt = () => {
        if (window.confirm(`Are you sure you want to adopt ${pet.name}? This action cannot be undone.`)) {
            axios.delete(`http://localhost:8000/api/delete/${id}`)
                .then(res => {
                    console.log(res);
                    showToast(`${pet.name} has been adopted! 🎉`, 'success');
                    setTimeout(() => {
                        navigate('/');
                    }, 2000);
                })
                .catch(err => {
                    console.log(err);
                    showToast('Something went wrong', 'error');
                });
        }
    };

    if (loading) {
        return (
            <div className='app-container'>
                <div className="navbar navbar-light">
                    <h1>Pet Shelter</h1>
                    <Link to={'/'}>back to home</Link>
                </div>
                <div className="loading">
                    <div className="spinner"></div>
                    <p className="loading-text">Loading pet details...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='app-container fade-in'>
            {toast && (
                <div className="toast-container">
                    <div className={`toast ${toast.type}`}>
                        <span className="toast-icon">
                            {toast.type === 'success' ? '✅' : '❌'}
                        </span>
                        <span className="toast-message">{toast.message}</span>
                    </div>
                </div>
            )}

            <div className="navbar navbar-light">
                <h1>Pet Shelter</h1>
                <Link to={'/'}>back to home</Link>
            </div>

            <div className="details-container">
                <div className='details-header'>
                    <h3>Details about: {pet.name}</h3>
                    <button 
                        onClick={handleAdopt} 
                        type="button" 
                        className="btn btn-danger"
                    >
                        Adopt {pet.name}
                    </button>
                </div>

                <div className='details-card scale-in'>
                    <div className='detail-row'>
                        <h4 className='detail-label type'>Pet Type</h4>
                        <p className='detail-value'>{pet.type}</p>
                    </div>

                    <div className='detail-row'>
                        <h4 className='detail-label description'>Description</h4>
                        <p className='detail-value'>{pet.description}</p>
                    </div>

                    {(pet.skill1 || pet.skill2 || pet.skill3) && (
                        <div className='detail-row'>
                            <h4 className='detail-label skills'>Skills</h4>
                            <div className='skills-list'>
                                {pet.skill1 && <span className='skill-badge'>{pet.skill1}</span>}
                                {pet.skill2 && <span className='skill-badge'>{pet.skill2}</span>}
                                {pet.skill3 && <span className='skill-badge'>{pet.skill3}</span>}
                            </div>
                        </div>
                    )}

                    <div className='like-section'>
                        <button 
                            onClick={handleLike} 
                            type="button" 
                            className="btn btn-success"
                            disabled={liked}
                        >
                            {liked ? 'Liked! ❤️' : 'Like'}
                        </button>
                        <span className='like-count'>
                            {pet.likes || 0} like{pet.likes !== 1 ? 's' : ''}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Details;